import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, ValidationOptions, Controller } from 'react-hook-form';
import { validateRequired } from 'utils/form';
import { CustomSelect, CustomSelectProps } from './CustomSelect';

export interface CustomSelectFieldProps extends CustomSelectProps {
	validation?: ValidationOptions;
}

export const CustomSelectField = ({
	name,
	onChange,
	validation = {},
	required,
	...props
}: CustomSelectFieldProps) => {
	const { t } = useTranslation('errors');
	const { errors, control } = useFormContext();

	const localError = useMemo(() => errors[name], [errors, name]);

	const error = useMemo(
		() => localError?.message || localError?.types?.message,
		[localError],
	);

	return (
		<Controller
			control={control}
			name={name}
			rules={{
				...validateRequired(true, t('required')),
				...validation,
			}}
			as={
				<CustomSelect
					name={name}
					error={error}
					required={required}
					{...props}
				/>
			}
		/>
	);
};
